import getConfig from 'next/config'

import type { Context as CartContext } from '@grandvisionhq/carts-v2'
import type { CheckoutSettings, Routes } from '@grandvisionhq/checkout-v2'
import { Util as StoreUtils } from '@grandvisionhq/stores-v2'
interface SettingsInput {
  cart: CartContext.CartContextModel['cart']
}

const { publicRuntimeConfig } = getConfig()
const { orderTimeOut } = publicRuntimeConfig.checkout

export const basePath = '/checkout'
const routes: Routes = {
  shipping: {
    label: 'Envío',
    path: `${basePath}/envio`,
  },
  overview: {
    label: 'Resumen',
    path: `${basePath}/resumen`,
  },
  payment: {
    label: 'Pago',
    path: `${basePath}/pago`,
  },
}

export const getCheckoutConfig = ({ cart }: SettingsInput): CheckoutSettings => {
  return {
    account: {
      implicitAccountCreation: false,
      createAccountRequired: false,
    },
    consent: {
      implicitTermsAndConditions: true,
    },
    shippingDetails: {
      loadingFinished: Boolean(cart) || cart === null,
      ...(cart?.billingAddress ? { billingAddress: cart.billingAddress } : {}),
      ...(cart?.shippingAddress ? { deliveryAddress: cart.shippingAddress } : {}),
      ...(cart?.customerDetails ? { customer: cart.customerDetails } : {}),
    },
    shippingFormFields: {
      billingAddress: [
        'firstName',
        'lastName',
        'streetName',
        'streetNumber',
        'additionalStreetInfo',
        'postalCode',
        'city',
        'region',
      ],
      contactDetails: ['email', 'phone', 'customerVatId'],
    },
    storeFinder: {
      showUseMyLocation: true,
      searchWhitelist: ['storeName', 'postalCode', 'streetName', 'town'] as StoreUtils.SearchKey[],
    },
    ...(orderTimeOut ? { orderCreationTimeOutLimit: orderTimeOut } : {}),
    features: {
      isCompanyEnabled: false,
      isServiceStoreEnabled: true,
    },
    login: {
      disableSignup: true,
      returnPath: cart ? `${routes.shipping?.path}?cartId=${cart.id}` : routes.shipping?.path,
    },
    routes,
    payments: {
      applePay: {
        merchantName: 'GrandOptical',
      },
    },
    logoVariant: 'alternative',
  }
}
